export const REFCODES: {[key: string]: string} = {
  NAV: 'nav',
  SEARCH: 'jssearch',
  ORG_SEARCH: 'search',
  CATEGORY: 'cl',
  TAG: 'kp',
  LEARNING_CENTER_CAT: 'catTab',
  LEARNING_CENTER_JD: 'jdTab',
  FEATURED_INSTITUTES: 'featuredInst',
  WEB_SIDEBAR: 'webnotifsidebar',
};

export const PRIMARY_SOURCE_MAP = {
  cl: 1,
  rl: 2,
  ep: 3,
  jf: 4,
  kp: 5,
  en: 6,
  sp: 7,
  hp: 8,
  enf: 9,
  pp: 10,
  ln: 11,
  tm: 12,
  LiJobs: 21,
  glassdoor: 22,
  recruit: 23,
  jobrapido: 24,
  trovit: 25,
  careerjet: 26,
  simplyhired: 27,
  mitula: 28,
  jobisjob: 29,
  recom: 30,
  recom_push_ios: 31,
  recom_push_android: 32,
  linkedin: 33,
  indeed: 34,
  adsafari: 36,
  adzuna: 37,
  workcircle: 38,
  jooble: 39,
  clickindia: 40,
  jobsmart: 41,
  jobtome: 42,
  sercanto: 43,
  jora: 44,
  neuvoo: 45,
  techslash: 46,
  googlejob: 104,
  hpjob: 47,
  rl_aj: 49,
  bj: 51,
  db: 53,
  psj: 54,
  scp: 55,
  recom_email: 57,
  recom_apply: 58,
  recom_ev: 59,
  ep_more: 60,
  ep_sec2: 61,
  ep_sec2_more: 62,
  ejf_tags: 63,
  ejf_mytags: 64,
  ejf_meta: 65,
  ep_ev: 66,
  ep_sec2_ev: 67,
  ep_more_ev: 68,
  ep_sec2_more_ev: 69,
  recom_ev_com: 70,
  recom_push_android_com: 71,
  recom_push_ios_com: 72,
  em: 73,
  ep_weekly: 74,
  ep_more_weekly: 75,
  recom_unpub: 76,
  active_push_android: 82,
  active_push_ios: 83,
  enf_top: 84,
  push: 85,
  custom404: 89,
  jsChatbot: 90,
  wfh: 91,
  ep_ev_ml: 97,
  recom_ev_ml: 98,
  recom_bn: 99,
  jf_prm: 111,
  jf_list_prm: 112,
  cl_prm: 113,
  cl_list_prm: 114,
  kp_prm: 115,
  kp_list_prm: 116,
  rl_aj_prm: 117,
  rl_aj_list_prm: 118,
  ev_recom_seg4: 119,
  ev_recom_seg7: 120,
  jf_pml: 121,
  ev_earlyapp: 122,
  jf_ml: 106,
  clp_p: 107,
  clp_e: 108,
  clp_f: 109,
  ambitionbox: 96,
  whatjob: 100,
  careesma: 105,
  rzwebnotif: 56,
  ep_old: 92,
  ep_old_more: 93,
  ep_old_sec2_more: 94,
  ep_old_sec2: 95,
  kp_car_br_prm: 103,
  kp_car_m_br_prm: 110,
  cl_p_prm: 123,
  cl_p: 124,
  cl_m_prm: 125,
  cl_m: 126,
  cl_br_prm: 127,
  cl_br: 128,
  cl_p_br_prm: 129,
  cl_p_br: 130,
  cl_m_br_prm: 131,
  cl_m_br: 132,
  kp_br_prm: 133,
  kp_br: 134,
  kp_p_prm: 135,
  kp_p_br_prm: 136,
  kp_p_br: 137,
  kp_p: 138,
  kp_m_prm: 139,
  kp_m_br_prm: 140,
  kp_m_br: 141,
  kp_m: 142,
  cl_list_p_prm: 143,
  cl_list_m_prm: 144,
  cl_list_p_br_prm: 145,
  cl_list_br_prm: 146,
  cl_list_m_br_prm: 147,
  cl_car_p_prm: 148,
  cl_car_prm: 149,
  cl_car_m_prm: 150,
  cl_car_p_br_prm: 151,
  cl_car_br_prm: 152,
  cl_car_m_br_prm: 153,
  kp_list_p_prm: 154,
  kp_list_m_prm: 155,
  kp_list_p_br_prm: 156,
  kp_list_br_prm: 157,
  kp_list_m_br_prm: 158,
  kp_car_p_prm: 159,
  kp_car_prm: 160,
  kp_car_m_prm: 161,
  kp_car_p_br_prm: 162,
  rl_aj_br_prm: 163,
  rl_aj_br: 164,
  rl_prm: 165,
  rl_br_prm: 166,
  rl_br: 167,
  ev_premium_jobs: 168,
  sp_prm: 169,
  sp_br_prm: 170,
  sp_br: 171,
  jp_sp_codingninja: 172,
  jp_fp_codingninja: 173,
  googlejobs: 174,
  internship: 175,
  walkin: 176,
  hiristtechtalk: 177,
  google_jobs_apply: 178,
  geeksforgeeks: 180,
  google: 181,
  FB: 182,
  linkedin_ad: 183,
  clp_k: 184,
  clp_k_other: 185,
  AT_NZ: 179,
  AT_SH: 186,
  AT_133727: 187,
  AT_135422: 188,
  dv360: 191,
};
